// YUNIQ Landing Page — shared interactivity for yuniq-lp-* sections

(function () {
  'use strict';

  // ─── Finish tabs ───────────────────────────────────────────────────────
  function initFinishTabs() {
    const tabBar = document.getElementById('yqlp-finish-tabs');
    if (!tabBar) return;

    const ctaLink = document.getElementById('yqlp-fin-cta');
    const ctaBase = ctaLink ? ctaLink.getAttribute('href').split('?')[0] : '/pages/card-customizer';

    // Apply sold-out state from stock data
    const section = document.getElementById('finishes');
    const stockData = section ? JSON.parse(section.dataset.finishStock || '{}') : {};
    document.querySelectorAll('.yqlpfn__item').forEach(el => {
      const key = el.dataset.finishKey;
      if (key && stockData[key] === false) el.classList.add('sold-out');
    });

    function selectFinish(el) {
      const panel = el.closest('.yqlpfn__panel');
      panel.querySelectorAll('.yqlpfn__item').forEach(i => i.classList.remove('selected'));
      el.classList.add('selected');
      const nameEl = document.getElementById('yqlp-fin-name');
      const descEl = document.getElementById('yqlp-fin-desc');
      if (nameEl) {
        const parts = el.dataset.name.split(' ');
        const last = parts.pop();
        nameEl.innerHTML = parts.join(' ') + ' <em>' + last + '</em>';
      }
      if (descEl && el.dataset.desc) descEl.textContent = el.dataset.desc;
      const finishKey = el.dataset.finishKey;
      if (ctaLink) {
        ctaLink.href = finishKey ? ctaBase + '?yc_f=' + finishKey : ctaBase;
      }
    }

    tabBar.addEventListener('click', (e) => {
      const tab = e.target.closest('.yqlpfn__tab');
      if (!tab) return;
      const t = tab.dataset.tab;
      document.querySelectorAll('.yqlpfn__tab').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.yqlpfn__panel').forEach(p => p.classList.remove('active'));
      tab.classList.add('active');
      const panel = document.getElementById('yqlp-panel-' + t);
      if (panel) {
        panel.classList.add('active');
        const first = panel.querySelector('.yqlpfn__item:not(.sold-out)');
        if (first) selectFinish(first);
      }
    });

    document.querySelectorAll('.yqlpfn__item').forEach(el => {
      el.addEventListener('click', () => {
        if (!el.classList.contains('sold-out')) selectFinish(el);
      });
    });

    // Auto-select first available finish in the default active panel on load
    const firstPanel = document.querySelector('.yqlpfn__panel.active');
    if (firstPanel) {
      const first = firstPanel.querySelector('.yqlpfn__item:not(.sold-out)');
      if (first) selectFinish(first);
    }
  }

  // ─── Carousel ──────────────────────────────────────────────────────────
  function initCarousel() {
    const car = document.getElementById('yqlp-carousel');
    if (!car) return;
    const step = () => {
      const first = car.firstElementChild;
      return first ? Math.max(300, first.getBoundingClientRect().width + 20) : 300;
    };
    const prev = document.getElementById('yqlp-carousel-prev');
    const next = document.getElementById('yqlp-carousel-next');
    if (prev) prev.addEventListener('click', () => car.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => car.scrollBy({ left:  step(), behavior: 'smooth' }));
  }

  // ─── FAQ accordion ─────────────────────────────────────────────────────
  function initFaq() {
    document.querySelectorAll('.yqlpfq__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        btn.parentElement.classList.toggle('open');
      });
    });
  }

  // ─── Scroll reveal ─────────────────────────────────────────────────────
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('yqlp-in'); });
    }, { threshold: 0.1 });
    document.querySelectorAll('.yqlp-reveal').forEach(el => io.observe(el));
  }

  // ─── Video scrub ───────────────────────────────────────────────────────
  function initScrub() {
    const section = document.getElementById('yqlp-scrub');
    if (!section) return;

    const bar  = document.getElementById('yqlp-scrub-bar');
    const kw   = document.getElementById('yqlp-scrub-kw');
    const sub  = document.getElementById('yqlp-scrub-sub');
    const card = document.getElementById('yqlp-scrub-card');
    const vid  = document.getElementById('yqlp-scrub-vid');

    function update() {
      const r = section.getBoundingClientRect();
      const total = section.offsetHeight - window.innerHeight;
      const p = Math.max(0, Math.min(1, -r.top / total));

      if (bar) bar.style.width = (p * 100) + '%';

      if (card) {
        card.style.transform = 'rotateY(' + (p * 360) + 'deg)';
        const glow = (p > 0.25 && p < 0.75) ? '0 0 40px rgba(212,175,120,0.25)' : '0 0 10px transparent';
        card.style.boxShadow = '0 20px 60px -10px rgba(0,0,0,0.7), ' + glow;
      }

      if (vid && vid.duration) vid.currentTime = p * vid.duration;

      const show = p > 0.18 && p < 0.88;
      if (kw)  kw.classList.toggle('show', show);
      if (sub) sub.classList.toggle('show', show);
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  // ─── Init ──────────────────────────────────────────────────────────────
  function init() {
    initFinishTabs();
    initCarousel();
    initFaq();
    initReveal();
    initScrub();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
